export default "__VITE_ASSET__B_etvC18__"